import { render } from "./CreateSnapshotFromVMSnapshot.vue?vue&type=template&id=84f0d12a&scoped=true"
import script from "./CreateSnapshotFromVMSnapshot.vue?vue&type=script&lang=js"
export * from "./CreateSnapshotFromVMSnapshot.vue?vue&type=script&lang=js"

import "./CreateSnapshotFromVMSnapshot.vue?vue&type=style&index=0&id=84f0d12a&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84f0d12a"]])

export default __exports__